<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands =[
  {
    "num_cand": "U2FsdGVkX1/Oswu55T2/WS7LBzU+PoUyLTd+SnBsKJc=",
    "cpf": "U2FsdGVkX1/UdOrz8EMqQA3yhr7gHHkB3yvUF3usSFc="
  },
  {
    "num_cand": "U2FsdGVkX1/5CIIdeRMI1BPux6EzmDhtxYcm76BPZOo=",
    "cpf": "U2FsdGVkX1/oD+h95jZyNaaq+2KpNitqUfKftktW7A8="
  },
  {
    "num_cand": "U2FsdGVkX18zg0XTlxL2DiZqyX5DSo0X/416Ekr4szs=",
    "cpf": "U2FsdGVkX18toNCmh2hg171MRMM1bhcCjM1PoDoTr1o="
  },
  {
    "num_cand": "U2FsdGVkX18dfVOpDRxBuS22btk4a9AgrdCdZtPMLvI=",
    "cpf": "U2FsdGVkX1/YNGqIEgFhkOfZThzSnVwzd6UUsLDrD4M="
  },
  {
    "num_cand": "U2FsdGVkX1/lhNeWX4GW/i9TXmt0qS5oawVLRPl2+6Q=",
    "cpf": "U2FsdGVkX19/gYhWZuSpF3QP5XliU+RoAnCj17x1fEo="
  },
  {
    "num_cand": "U2FsdGVkX19dTvD/IObPxpQgNBVS2JCmzi5IZHDnI8U=",
    "cpf": "U2FsdGVkX19/GRK7HSu4Ioa6HD5XVb9vaR7ILpzgvnI="
  },
  {
    "num_cand": "U2FsdGVkX1+nLW73CnDV5/Kc7j1d6wvRm89Fhk1bGuo=",
    "cpf": "U2FsdGVkX1/zjbwintzrhIAQdkketuZ56sal9TtQ6vM="
  },
  {
    "num_cand": "U2FsdGVkX19o1wpJDOgexbMYRKVNvIgSVKDSEU6qRhc=",
    "cpf": "U2FsdGVkX1/ATgcKZX2oAWiNbylvJKzFpmWHvoXB9bA="
  },
  {
    "num_cand": "U2FsdGVkX19111zEcHn92ScNK9Q+bPZa1U7jNJUWJkM=",
    "cpf": "U2FsdGVkX190QUjHgWHlIowZ2jo/9YwXjJElykSpVVc="
  },
  {
    "num_cand": "U2FsdGVkX19kXxGnQaYzcCh7I3QvlRehQxE6gkPxeTU=",
    "cpf": "U2FsdGVkX19lSXnd2nyhF2X8kKsMaSzQxIJNHX2Xp+s="
  },
  {
    "num_cand": "U2FsdGVkX1/D8/Lx/29sYmXL5sMBIZsQKzA+OouNXFo=",
    "cpf": "U2FsdGVkX1919sIoW7R9iUPDzwurL0orXLbq2Bxc3N4="
  },
  {
    "num_cand": "U2FsdGVkX1/658Ozz6mfec5P5kA4vJDd4sSbIRCLnpM=",
    "cpf": "U2FsdGVkX19iR4WJdXNnrKP8oWBe1QMRkKlJRF35MB0="
  },
  {
    "num_cand": "U2FsdGVkX1+ZQ738larPcwCtPQqNGO2J706zA0Kwgmo=",
    "cpf": "U2FsdGVkX19ZCD38f/QbALrBR24K7JavI8ueNceCwBg="
  },
  {
    "num_cand": "U2FsdGVkX19J5H2eO5xBFIpPRASPsA5TX38nRxyZ2zo=",
    "cpf": "U2FsdGVkX1/pOm87oTaoVIUZaxCz+waDXqHBZqGJTTM="
  },
  {
    "num_cand": "U2FsdGVkX1/c9rPSVs6AVWRU3cItK7H6LM8RR4tYY2k=",
    "cpf": "U2FsdGVkX1+KwITjJ52F2a/Ogw6fT7h2qP9qVcJ1lI0="
  },
  {
    "num_cand": "U2FsdGVkX19gOq/FDJOIJ7QIBldF/kdNYSChzDe3o1k=",
    "cpf": "U2FsdGVkX19HX4bc72WIlAaLIrEQ8D/0npOKIimvgJg="
  },
  {
    "num_cand": "U2FsdGVkX18q4ek7WzzTWgqSKDV+u60igOTeIS5Oo0w=",
    "cpf": "U2FsdGVkX18z9b9G7gXhGSCNeNGNywoYU0Gdde96tIo="
  },
  {
    "num_cand": "U2FsdGVkX1+9u8Ip4a+C4lu99cQkECQcfV6bkkmyqe8=",
    "cpf": "U2FsdGVkX1/DIqtVG8BDsGbksxgZoqiUbwJo6PVvgf0="
  },
  {
    "num_cand": "U2FsdGVkX18FjADm1X0ulvz39lHWbNn7GBf1wtcWEcg=",
    "cpf": "U2FsdGVkX18VrF3ezXcryyl9kojIvSRo/Qsc+QQ7zNk="
  },
  {
    "num_cand": "U2FsdGVkX1+PqOAfQf7643EwEWsrmth13CVI+qr7AFg=",
    "cpf": "U2FsdGVkX18/cQRAp4QHKy0czHI6xnlzaqPMY0JCi5E="
  },
  {
    "num_cand": "U2FsdGVkX18NTay7cKoI1zhrf7iKHANCry4sOQOWwXU=",
    "cpf": "U2FsdGVkX18snvOguTgdy1XFbI2TYCHzYANiJAssCYw="
  },
  {
    "num_cand": "U2FsdGVkX18BR95XJbB4WpSP42WCBbZohbGU5/dKMdg=",
    "cpf": "U2FsdGVkX19zeiSyQoetcmOafczBPfH10AeI9f2TZNE="
  },
  {
    "num_cand": "U2FsdGVkX188YBL9uddR2nNaib/Acz++sKKLgrXi36Y=",
    "cpf": "U2FsdGVkX1/Uxl5eiDwmZzRGuagevwZWgp2Sft3ScAc="
  },
  {
    "num_cand": "U2FsdGVkX1+9+b7Fan8yuRd4bK7qVuetkyv2J5Y727k=",
    "cpf": "U2FsdGVkX1/fsbcJ+/hIM5xPu2m6FwS2OBl0d+DBZEY="
  },
  {
    "num_cand": "U2FsdGVkX1/ugMERRgreTAbPwLahDk+KxXvixpZFAaQ=",
    "cpf": "U2FsdGVkX18swDJaAQd2pUH8FKmgnLtx345YtzT/fk4="
  },
  {
    "num_cand": "U2FsdGVkX19fvvM//xAt+B97k3LbzutH03ZLPEexb6s=",
    "cpf": "U2FsdGVkX19BK+hTMCvfYYKWL7DCLvRiev2OBZSPG2o="
  },
  {
    "num_cand": "U2FsdGVkX18mQiMG1k6zpxa0TNHwLZBDRtEzJyvj/CQ=",
    "cpf": "U2FsdGVkX1/d90EI2rAp1MMW6bEjGKUaLUbkhnpvjX8="
  },
  {
    "num_cand": "U2FsdGVkX18dDdwo44BkdswKcDWGGucMKD9sdtfFht8=",
    "cpf": "U2FsdGVkX19gOzMjh7QmFMFlmHyiyDY+BKy9DO09gO4="
  },
  {
    "num_cand": "U2FsdGVkX1880spt5FOxtOjGhWj3C3mCeTsBdcANa3o=",
    "cpf": "U2FsdGVkX19xAnQMMikYQUQDT87agJQ4oZSUBtisQgc="
  },
  {
    "num_cand": "U2FsdGVkX1/pprZM8afrzGHL/LVLYdt6AMER313qC5w=",
    "cpf": "U2FsdGVkX1/LQi3Wla7kz4zTXR4hzTsYfA9+tJAUDKQ="
  },
  {
    "num_cand": "U2FsdGVkX1/La7mOUTvPLIj+Q5i3y4fmLJsPm3zj5XE=",
    "cpf": "U2FsdGVkX18jO33uaLvaLIvH8Yxq6W4OJ9LvBmUqDP0="
  },
  {
    "num_cand": "U2FsdGVkX18g8Rmu/FJb1nBBrExjgO88lzBNa3OTnY4=",
    "cpf": "U2FsdGVkX19XcOmuZVPS8K5Qd1tYGyVs44CcmDJOleE="
  },
  {
    "num_cand": "U2FsdGVkX1+8A3kBrtTImDNqQSE/eSrGUCYmcKod/es=",
    "cpf": "U2FsdGVkX19wLOUT/TAB9ytsZK1//3ZeZIxoeKqghC8="
  },
  {
    "num_cand": "U2FsdGVkX1+5YPvwp0I6nkEp47nd3WuR4JY0wyZrkCI=",
    "cpf": "U2FsdGVkX1++rvzEkzlNal4aVNRLjHSQR2VipzcBmWg="
  },
  {
    "num_cand": "U2FsdGVkX1/NM94lMoFzUTDdnT+Kp+uR87JBDAvWmGU=",
    "cpf": "U2FsdGVkX19lQhYTitPjgZWpRC7BWR02gD+DVIM9p4g="
  },
  {
    "num_cand": "U2FsdGVkX18HoYtb9M+F+E29sW9Cbhb/6oxtZykxbWQ=",
    "cpf": "U2FsdGVkX18nwMWPxiZbhuZ457BOzLovNS7UzBci4u4="
  },
  {
    "num_cand": "U2FsdGVkX19NHHhp6XRDT4d1oXYQ7wBGAa/VMLCnsnQ=",
    "cpf": "U2FsdGVkX1/vhWVlaI0+Yeh9HpEay0Fev5Ujr3yFfCI="
  },
  {
    "num_cand": "U2FsdGVkX18Bm2WBxIGk26i9HEwA5VWsX0DRf7JYxpo=",
    "cpf": "U2FsdGVkX194MPdF2omOfPeMYQrsDFtrOlhZZNOEaPw="
  },
  {
    "num_cand": "U2FsdGVkX18gLaLw8YmKWWDIHBBjtC6wSvz+DjQnOG0=",
    "cpf": "U2FsdGVkX1/BgwCJEDUZJ05a7rC53Baqowmmc1qsTrs="
  },
  {
    "num_cand": "U2FsdGVkX1+wlWQZsgzJuI1YrhcyiFl5D0Wdk9o5pUU=",
    "cpf": "U2FsdGVkX19ZMj1cL3AfJ2NLKLTC/fh9lZDz4gvv4yE="
  },
  {
    "num_cand": "U2FsdGVkX18LyDM+I/CLAd86zZgUT+yk7IG9yyIpsCQ=",
    "cpf": "U2FsdGVkX1886ZvuzA5v5L0aY+DgwEem2+d5nfGdYa0="
  },
  {
    "num_cand": "U2FsdGVkX19Aj6XZOk3iZic0xjn2JzaI7tcmqLI7W9I=",
    "cpf": "U2FsdGVkX18rnO7Rm//H9ClSo1+32yFwVEHTYqenRmw="
  },
  {
    "num_cand": "U2FsdGVkX1+jta66Ub0V06rKUBpHuUx/p9WZ89oDOZQ=",
    "cpf": "U2FsdGVkX19XV9uhW5UPaq4szf1RhWQyBkKlTRywGQs="
  },
  {
    "num_cand": "U2FsdGVkX1/7+H3k4OpTxtk0RfWkr4o0hw4F2N0OMXs=",
    "cpf": "U2FsdGVkX19QRNhnaj7aAu0UwoRrbtqCbEutHgvU0UM="
  },
  {
    "num_cand": "U2FsdGVkX1+/jNNsuRC1WsJmW5BdT8AlZPK91bxuP/Q=",
    "cpf": "U2FsdGVkX1/zekJtFGDIi7KVVqDjeD+fqk2f6ZT+T+U="
  },
  {
    "num_cand": "U2FsdGVkX19DEZlXdDHXhYgjBHsG9T6EC+j2Rw0FWrM=",
    "cpf": "U2FsdGVkX1+zQdC5A6WH6KVOKsyHPrsEgjGN5IPmZdo="
  },
  {
    "num_cand": "U2FsdGVkX19xhZ2ZpvNtyFxfv2zDY1WlM3gcQ5j7UQQ=",
    "cpf": "U2FsdGVkX1/fYZI/BAE0BTbj6QhfiBQW/x4daCB4xXE="
  },
  {
    "num_cand": "U2FsdGVkX19i+d4OsPtpLOR+tnxNxzkbthYXIWgWaOI=",
    "cpf": "U2FsdGVkX1+3S0tOyiuRQbjGPrTOC1AxUWxJWiPLL7I="
  },
  {
    "num_cand": "U2FsdGVkX1/UZZemBBg8ZGt6hGTugFsTFMZuopHXfmA=",
    "cpf": "U2FsdGVkX1+eihp5Sii1Rc44I9Vj6C9t1n2KNZoohQE="
  },
  {
    "num_cand": "U2FsdGVkX19XQyns0uPOENVXOsBQuon+rY+aZLMgv9Q=",
    "cpf": "U2FsdGVkX19vqpW7jlst6jdo27MYsch0ZxPhEunkBGE="
  },
  {
    "num_cand": "U2FsdGVkX1+yQvFQASyUV6sXDASkl8wA0SarZrwY9FU=",
    "cpf": "U2FsdGVkX18jK+9jCZUpTWAClikz3x0Sq+510FvKmP8="
  },
  {
    "num_cand": "U2FsdGVkX1/xQ+JWS/Fls+F3QTxxHEqNq+18SSbf+Eo=",
    "cpf": "U2FsdGVkX1/qGDWsgvlyxU6zRagvxzcBrFxadn+B7zM="
  },
  {
    "num_cand": "U2FsdGVkX18oFDmjNEPb2WqQmBZN0mjMjiGEr3pP7A8=",
    "cpf": "U2FsdGVkX19JPc4oa+YPVwJuaPHo7ys5QACjlW/bJAU="
  },
  {
    "num_cand": "U2FsdGVkX19WzUvsoLKdBk6gVWus5xGthLsYvLuxel0=",
    "cpf": "U2FsdGVkX1/Z0DsRcfhiQd4dKweZiHYcDX685G0Qby8="
  },
  {
    "num_cand": "U2FsdGVkX18WtEfc1ekuNwRefymWmQxRKLjeQM0+P2Q=",
    "cpf": "U2FsdGVkX19uNmvnierZqDTwRQnayeeDrxQKrnq3h8M="
  },
  {
    "num_cand": "U2FsdGVkX1+5xTj6AYpLDNjIyFGisdtxpTf1ualDO34=",
    "cpf": "U2FsdGVkX1+uFnG6//VvM5rAS+rvuDTW7Ziztvnk+lw="
  },
  {
    "num_cand": "U2FsdGVkX19S4cLmWCurEWxBl5+wd+VH4UiuDHxk4rc=",
    "cpf": "U2FsdGVkX19XGp1NZOmJ13jlsY8qlvg3qiWKMK72vY8="
  },
  {
    "num_cand": "U2FsdGVkX1+PMwf4sZmP7cRTr/NGPiLzyDtQqh9wMMY=",
    "cpf": "U2FsdGVkX18K8Y0Qwjdqk2tFYCxqPs6qZWVBFKrTFsA="
  },
  {
    "num_cand": "U2FsdGVkX19JQTxNyN+2qT3mHtuVBWi+UzVFliu4Rrg=",
    "cpf": "U2FsdGVkX19ko6umGWFpDmQSCLfVVuvAro6FXwAb/ws="
  },
  {
    "num_cand": "U2FsdGVkX1+ZwtFOvYj+3Q7fxt2hUO3UJWURHLkaWoE=",
    "cpf": "U2FsdGVkX19BD6Y7AIzPnrpRvCzCGsgXJR4ehbCDeik="
  },
  {
    "num_cand": "U2FsdGVkX18XqG3QMO5ki8HBayaOdacStML/zXriZ50=",
    "cpf": "U2FsdGVkX1+WqEdPxe0smaKnKficMd9K+OzmWFE74t8="
  },
  {
    "num_cand": "U2FsdGVkX1+Zj89vXyFEPBqWY7GF2aDmaeluVb+MoyM=",
    "cpf": "U2FsdGVkX1/RQ6Cz6PGzqSBJ5YzO0SbtizQQTUUNGIg="
  },
  {
    "num_cand": "U2FsdGVkX185JdubVQGjkyN1xGPJVobw7JiaDZIwWFQ=",
    "cpf": "U2FsdGVkX19esiy7UH3oyIvSr0bKFXreB96NBT+soW4="
  },
  {
    "num_cand": "U2FsdGVkX1+zmymn4iOBJa+zFQbiLsSgtQnFAkh+M3w=",
    "cpf": "U2FsdGVkX1+HHpkdWeHky0xMZF9+t7jlARwpmMER05c="
  },
  {
    "num_cand": "U2FsdGVkX1953PxoepNIqAig0aeP8rUEZOia31o/54k=",
    "cpf": "U2FsdGVkX19vy8pyaN6YrBTZGFQrH4TEz0LU67yKY/8="
  },
  {
    "num_cand": "U2FsdGVkX1/WodYl/1q6UYpixUUuF/z1yxP4V+H49kw=",
    "cpf": "U2FsdGVkX1+M3CUUsvjYwC+GEiiD8X3CzyYuH55CASU="
  },
  {
    "num_cand": "U2FsdGVkX19DydFz2wWURtEQAAko7vzZwPCSRFjvedw=",
    "cpf": "U2FsdGVkX1+UP4NwG6UI8Ir9ePeQEYYlGq45lvm9WtM="
  },
  {
    "num_cand": "U2FsdGVkX18vhBlzlEWTyk93yY/7m65kcg3gcnI+N14=",
    "cpf": "U2FsdGVkX1/ZNmz9oaBWz+1fn0o61N7HUyiDF5w6T28="
  },
  {
    "num_cand": "U2FsdGVkX1/JATtWzzr0HKHfpUflh/NkrYOzimpzS6c=",
    "cpf": "U2FsdGVkX1+JEimnDRUfnF7d7yTsk8vCAxKQfRmsV2U="
  },
  {
    "num_cand": "U2FsdGVkX1/D5mACxoGsOuKyY7QqJkHdX+4WQF9Yi9o=",
    "cpf": "U2FsdGVkX18fF7D5L38qVqhHfbvLn76xdWvftjxA9Aw="
  },
  {
    "num_cand": "U2FsdGVkX1/zR42CnQkC5h38w1n5U2uavX0iPszj0S0=",
    "cpf": "U2FsdGVkX19TFJLIluL38dPZTdJLBtb3VuWpPZ0vor8="
  },
  {
    "num_cand": "U2FsdGVkX18IWsC9J5D7MwRstyinTAerP+Idd8ngb2E=",
    "cpf": "U2FsdGVkX18HQVNJX5zBywBhVt/aXZhsfRyOBkth974="
  },
  {
    "num_cand": "U2FsdGVkX1/2el1KNtGZZ+lhxf4tjXjBZhgOJ9LsT3Q=",
    "cpf": "U2FsdGVkX18473F/4c2llnTbcKYOWJC2I4hZ3pBn5o8="
  },
  {
    "num_cand": "U2FsdGVkX19xfw/wKbQP9FFGUjZW86GIB4SZHWKdCfE=",
    "cpf": "U2FsdGVkX1+/ytkkenyO0MnsAWeydwVkFinCGTWdg0E="
  },
  {
    "num_cand": "U2FsdGVkX1/YZTHTzNDRzDGSm/qSJ/ed1gJx32Nvv1k=",
    "cpf": "U2FsdGVkX19ae8Q9TRnKiWGjbXherfjORKgNSaLMFd8="
  },
  {
    "num_cand": "U2FsdGVkX18Iz/RDHdoE1MCVT8KnqzD8/1HnFWiMwnk=",
    "cpf": "U2FsdGVkX195Z7G8J91pRxI1OnS/04sv1VRJnRew6Pk="
  },
  {
    "num_cand": "U2FsdGVkX19TYlIY+hQDfHhB3+/k/E3sQ0kU358LvZs=",
    "cpf": "U2FsdGVkX1+coSU75cJBJTiXYavrUX4ls9li18UlEaU="
  },
  {
    "num_cand": "U2FsdGVkX19bKUlzcmsrJtloh6sYnb4oUqjRht65fbU=",
    "cpf": "U2FsdGVkX197wbZqWKhnZwOzSDWEUSLdvgtMtLY8pPA="
  },
  {
    "num_cand": "U2FsdGVkX18QQZxi2vfMPp4ulI8LK4Zv+N7f8FATRJ0=",
    "cpf": "U2FsdGVkX18aOkxAP5GIXMh6GT7kYOEGPuMq/SiqOT4="
  },
  {
    "num_cand": "U2FsdGVkX1/Cifsk3eqpFSwdNHLJva+voWuLyqLqENw=",
    "cpf": "U2FsdGVkX1+wQLWf+orwXZVGfi4UarrTiqWp6Y/ec+I="
  },
  {
    "num_cand": "U2FsdGVkX1/xtlHLQQy93A5EeN/wRi5f8bWXEwK90XM=",
    "cpf": "U2FsdGVkX18w+fVF/DJy8KbiMMqumEaDzd0ZFLZ28xQ="
  },
  {
    "num_cand": "U2FsdGVkX1+gf6g5ND8QbjaUWrrXx1lQcKX9x+SmX60=",
    "cpf": "U2FsdGVkX19wNPwK33gbvDUutUb4BuWMgIYtnr+nzTs="
  },
  {
    "num_cand": "U2FsdGVkX1+mc8K3uRa3YD6ps5RIjRg0PvEuN07iwl0=",
    "cpf": "U2FsdGVkX19xR3zhYFLltE33wsTTwqJHTA17fVp7a6I="
  },
  {
    "num_cand": "U2FsdGVkX193CqrGNwBzhqgG9LZw6OXBx77wiay1HVQ=",
    "cpf": "U2FsdGVkX1/7Kot3wCmgIlgSjop5hWtE4junc69+U34="
  },
  {
    "num_cand": "U2FsdGVkX1+JhCJ1rEbJBPRfHJEPfnijyzivuMFmOGM=",
    "cpf": "U2FsdGVkX1+IGMKhIzCxnA22ClXsqtYvAdQD5Ape8bA="
  },
  {
    "num_cand": "U2FsdGVkX1+cq1HGJF+o6BpruLsbWqTu3S35hiYjAq4=",
    "cpf": "U2FsdGVkX1/6phi7lFqN65JisSyAiTfCmSooSLofdFA="
  },
  {
    "num_cand": "U2FsdGVkX1+GQnPPyaucWcxxXJynHyKOVE3msTUJiw4=",
    "cpf": "U2FsdGVkX1/t+7xP8Z9ib5lz7UcneVg/Xv7TNiE9w3A="
  },
  {
    "num_cand": "U2FsdGVkX1+gpn1E8sjOhevAcbzZnbo+Y8PL7Tsy+io=",
    "cpf": "U2FsdGVkX19ZmLKH7Cxdh1/2Ie3YVBaU75iDlRLUmRg="
  },
  {
    "num_cand": "U2FsdGVkX19HJCjaf6e7eLXnprW/ZcRqdIugKhdiMA0=",
    "cpf": "U2FsdGVkX1/vgT+pbOREk0tnTwGPPBjqqhuj6XcClHQ="
  },
  {
    "num_cand": "U2FsdGVkX19drnILOYn7u0I+qjFOntbR/PIDWRZnO1E=",
    "cpf": "U2FsdGVkX1/D/X6ImkbV3rYacl7pB95txNKag68mPD0="
  },
  {
    "num_cand": "U2FsdGVkX18MMqzf/u47n0iPRPX84/WZn3RA1OHT2qg=",
    "cpf": "U2FsdGVkX1+WZmXp7m5MQMsNGviwXiUEAys+siuazu8="
  },
  {
    "num_cand": "U2FsdGVkX19iojQqR9QpnIGfBm7jkEmLk/yahhd4YwQ=",
    "cpf": "U2FsdGVkX18P7olyOneC4MEjzEh8K6rh8CgD8OHTy5o="
  },
  {
    "num_cand": "U2FsdGVkX19p+L7CUEgfkWhz0ydSHT4jJMI5DkzzdTs=",
    "cpf": "U2FsdGVkX19qkfDbnbLh+kCtnyyPnkfDC5bZP7sdcsE="
  },
  {
    "num_cand": "U2FsdGVkX18zNVVctbs5pwVXqwTOnKFXgcAV194nJU4=",
    "cpf": "U2FsdGVkX1/OO5zWi+zckewwf0+VmvJhlYw/ARbtR0s="
  },
  {
    "num_cand": "U2FsdGVkX18tvbBMs30/FiYgoph7z0jNklW2jZI06GM=",
    "cpf": "U2FsdGVkX1/fUBBzlsoZUAXdGqEeUIMmJ68Yq7ufGkA="
  },
  {
    "num_cand": "U2FsdGVkX18QQLs5NtD8NOUnJBW2bVsYhQtWZeohK8U=",
    "cpf": "U2FsdGVkX1/Xnc2rN06HSt0Nw9F5I5ZuEGKm8BXfMK4="
  },
  {
    "num_cand": "U2FsdGVkX18jlS1eVy2lFF5YjTZ/CuD/LuJ+qiiSaP8=",
    "cpf": "U2FsdGVkX1+HH+HntMk4LuayhEqVGF/9EKZScAvSa7c="
  },
  {
    "num_cand": "U2FsdGVkX1/RzWzD/vo9Z34xunT272bWY8MXepz/F8M=",
    "cpf": "U2FsdGVkX1+WO8RkDGHcFEK74w8D0cLRHHgNk4fFW4I="
  },
  {
    "num_cand": "U2FsdGVkX1+E/AoqystDq/vZzKaxPHBlu+miIqGIffk=",
    "cpf": "U2FsdGVkX18upu+MtuyqdaKZQfLuvAoPzlRMAbxlSok="
  },
  {
    "num_cand": "U2FsdGVkX18YI0ND6l2Z9dm9oyxxQJzOxVuW2PGTB/w=",
    "cpf": "U2FsdGVkX1/KHt9T6cpoMNwL22Ax1FAX7eZNVK74/0s="
  },
  {
    "num_cand": "U2FsdGVkX1+hlxKEDmmqj54Y2PWZxUAjgSpVncniCNE=",
    "cpf": "U2FsdGVkX1+9leepjPPy02YZT5P9S7XwB4kSPlJ4vtc="
  },
  {
    "num_cand": "U2FsdGVkX1/1ggnTncmkghIBL17o9XrLnluZGX9GmCE=",
    "cpf": "U2FsdGVkX19N9jXStNaere/zwoVWS5xeOdaAKJ2hkPQ="
  },
  {
    "num_cand": "U2FsdGVkX1+tXSH9dEoKlO9qWRvBCwrilLPfymUAJ+E=",
    "cpf": "U2FsdGVkX1+2kvENASaHUOLBHij0hE4+n6KtL82gVcs="
  },
  {
    "num_cand": "U2FsdGVkX18dgcGa0kzjrhhaKP3Nib25s9BfmR0tDy8=",
    "cpf": "U2FsdGVkX19463jc876L861jD50Kn7wEH4XsY34wFDQ="
  },
  {
    "num_cand": "U2FsdGVkX18MnOvxH7O3kx3XUBNCr0FsUl8epHXpNC4=",
    "cpf": "U2FsdGVkX1++tNOrbQC1i5BIqig3VsKZEmlz+gzBCRE="
  },
  {
    "num_cand": "U2FsdGVkX1/8aDpO1U/56D0+13SoQ4csOfOKkig72kg=",
    "cpf": "U2FsdGVkX18IKwYaET58aCa7G169MrzZzVxmyp4Ktjg="
  },
  {
    "num_cand": "U2FsdGVkX184rrvoPK8+a/6ccDEJBQb4tRr3mYrmxKs=",
    "cpf": "U2FsdGVkX1/6ZNSJmRkUBTsNuEyewLWZIIh3/mYUuDk="
  },
  {
    "num_cand": "U2FsdGVkX1831k1wC5tzehkZ26I6HXAIQFe2p7UF2K0=",
    "cpf": "U2FsdGVkX1+czvOo9hwbTCS/U5Uq0qihsXb5IZGEy4I="
  },
  {
    "num_cand": "U2FsdGVkX1/QRwo3UI+vW7AS1D0HH9wZ5ixTcVVZ84Q=",
    "cpf": "U2FsdGVkX19rOemjxf8frDhKSbWxGc65eDixrRoI2S4="
  },
  {
    "num_cand": "U2FsdGVkX18BnQXFUJpUnCo40x1XXpke448nDc114wo=",
    "cpf": "U2FsdGVkX192mL/XooFT94eDu4h4+Jt5OS1QZ+bnq7w="
  },
  {
    "num_cand": "U2FsdGVkX1+PCMYQQEmXYZqFdtXjQZUQdb8KnFLuLNI=",
    "cpf": "U2FsdGVkX19DN3kRouxE6xQJzWn2ksCvoBM+nUMxmto="
  },
  {
    "num_cand": "U2FsdGVkX1/RLDf3N5GZ+1KFlmXzDfBkGUNLO2PU9qs=",
    "cpf": "U2FsdGVkX1+E5G3786suxoC941RRXKdI8ZAqh0u+l20="
  },
  {
    "num_cand": "U2FsdGVkX1/qzu3TZPHvZiTkBgVDO1EAlYmas4f3cOk=",
    "cpf": "U2FsdGVkX1/VooRknjJV9ZLs0w52/fDLW5C2FsfOK9A="
  },
  {
    "num_cand": "U2FsdGVkX18ZtAYCWRxQLAQfy5XmJbMayrxiqackkv8=",
    "cpf": "U2FsdGVkX1+pRduMVyJ6/20VlhJUG6gctc4SSWGrc4Y="
  },
  {
    "num_cand": "U2FsdGVkX1/UhLJPB8PoGCqY/ZWi9QyHTU55Mplp1KE=",
    "cpf": "U2FsdGVkX1/Q81mqMoFbnS64zGoIwsNEC387I+z3Y3Y="
  },
  {
    "num_cand": "U2FsdGVkX19F7pXKCECuGSDaJ/fdspkb7FytcfeKiHc=",
    "cpf": "U2FsdGVkX191w6FuomaMmt4CkDH4VjUEtxU3FINsDzI="
  },
  {
    "num_cand": "U2FsdGVkX19jlllTlM6Qmid3SEBxWybIQdc8Sf4vaXU=",
    "cpf": "U2FsdGVkX1/TT6BLoFKt3GmLxRm+4SCzTBI9Jwo5xSU="
  },
  {
    "num_cand": "U2FsdGVkX19XuAJFitJh0MptmE2AfYDVVJR9XelHzgs=",
    "cpf": "U2FsdGVkX19iG1/YZhmLiBeMNeyf2vwUCo4+yYvJdlc="
  },
  {
    "num_cand": "U2FsdGVkX1+m+biubUS9cAV5k3DZxJHuz3upoJhOYew=",
    "cpf": "U2FsdGVkX1/oqacehCScajtDOit+lOOsrJha8UuSj58="
  },
  {
    "num_cand": "U2FsdGVkX19uuCtgNdmhCa20JJlIGAOsgGDOT0EVaw8=",
    "cpf": "U2FsdGVkX18uZDuoynuAperxjv986Z+laYM6QCthZ80="
  },
  {
    "num_cand": "U2FsdGVkX18gAnoOqDf9F6k2+45BWvTTe7KYFLloYx0=",
    "cpf": "U2FsdGVkX1/dA6k4nPzs9ZTb8JC39gqw74qgJ4tH1I8="
  },
  {
    "num_cand": "U2FsdGVkX180/03JN5A7R5K9OWYQ84RYQa+FdoPoYZ0=",
    "cpf": "U2FsdGVkX18qqb5OjADebUEv6wC/lG4WtDfis73JKkM="
  },
  {
    "num_cand": "U2FsdGVkX19XtgKqD4lbLM0Eb+jIFHDCc7dXL9KuHSs=",
    "cpf": "U2FsdGVkX19ZaXRMwS4USAvqcduTA6azrVBuH9UxtyE="
  },
  {
    "num_cand": "U2FsdGVkX19tbDjXwLGJa07mDRBfVLNgt//WmPurTq0=",
    "cpf": "U2FsdGVkX19Cky7hmRius936x1lSPnbQu3lXKHdTzhc="
  },
  {
    "num_cand": "U2FsdGVkX1/zBQqaEVaBv2CtfpKxXadTBpZ4mI9v7Bw=",
    "cpf": "U2FsdGVkX1+emzj2ImEtUdvOBIf+OwHWY3pFUvYyXJk="
  },
  {
    "num_cand": "U2FsdGVkX1/2xA001pVCvMV8o61kTIC9WmMf7b2s6l8=",
    "cpf": "U2FsdGVkX1+1moXMjsUJy1sKFFX6GAadP+X3htlmFCk="
  },
  {
    "num_cand": "U2FsdGVkX18wDqHcAgoH5w3krp8a3XuOsgIyTwpd5JI=",
    "cpf": "U2FsdGVkX1/3kF6q/Le+7Wkzc0ZPjFmWfCHOyqUGnKg="
  },
  {
    "num_cand": "U2FsdGVkX1/19sAylOzEaIFmr9DPW3/Iedfs2casxqM=",
    "cpf": "U2FsdGVkX1+owye1cAbBH/KXjpJKJGFeacuntNs2YQ8="
  },
  {
    "num_cand": "U2FsdGVkX19x8vjTookd/wZinbHO6OjnZnoB7EKZXWI=",
    "cpf": "U2FsdGVkX1/aMhjpih871MgI8Lc0hutC5bnzrRU1BAw="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2113/2113_rec_gabx/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
